var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseCircleUnfilled = function SvgCloseCircleUnfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.83 11.83a1 1 0 0 1-.71-.295L8 9.415l-2.12 2.12a1.001 1.001 0 0 1-1.415-1.415L6.585 8l-2.12-2.12A1 1 0 1 1 5.88 4.465L8 6.585l2.12-2.12a1 1 0 1 1 1.415 1.415L9.415 8l2.12 2.12a1.001 1.001 0 0 1-.705 1.71ZM8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm0 14A8 8 0 1 1 8 0a8 8 0 0 1 0 16Z",
    clipRule: "evenodd"
  })));
};
export default SvgCloseCircleUnfilled;